import { RootState } from '@/store/main';
import { LeaderboardMultiplier } from '@/types/leaderboard.types';

export const getLeaderboardMainActions = (state: RootState): LeaderboardMultiplier[] => state.leaderboard.mainActionsOn;
export const getLeaderboardLoadingActions = (state: RootState): boolean => state.leaderboard.loadingActions;
export const getLeaderboardEnabled = (state: RootState) =>
  state.project.workingProject?.settings.leaderboard_settings?.enabled;
